module.exports = __webpack_public_path__ + "static/media/sustainability-scale-icon.bdea099c.svg";